__webpack_require__.p = "https://frontends.udemycdn.com/frontends-legal-terms/_next/";